/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withDynamicBundleAccordion } from '@thd-olt-component-middleware/pip';

import { BundleProductOverviewAccordionTitle as BundleProductOverviewAccordionTitleSlotG1Header, BundleSpecificationsAccordionTitle as BundleSpecificationsAccordionTitleSlotG1Header }
from '@thd-olt-component-react/product-bundle';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleSlotG1Header }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleSlotG1Header }
from '@thd-olt-component-react/ratings-and-reviews';

const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
};

const SlotG1KBody1Placeholder = null;

const SlotG1KBody1ClientK = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "bundleproductoverviewaccordiontitle" */
    '@thd-olt-component-react/product-bundle');
};

export const SlotG1KBody1LoadK = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-bundle'))
      .BundleProductDetails;
  },
  client: SlotG1KBody1ClientK,
  placeholder: SlotG1KBody1Placeholder || getPlaceholder({ skip: true }),
  name: 'BundleProductDetails',
});

lazySlots.LazySlotG1KBody1 = withLayout(
  SlotG1KBody1LoadK,

  null
  ,
  {
    waitForComponent: SlotG1KBody1ClientK,
    placeholder: SlotG1KBody1Placeholder || getPlaceholder({ skip: true })
  }
);

const SlotG1KBody2Placeholder = null;

const SlotG1KBody2ClientK = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "bundleproductoverviewaccordiontitle" */
    '@thd-olt-component-react/product-bundle');
};

export const SlotG1KBody2LoadK = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-bundle'))
      .BundleSpecifications;
  },
  client: SlotG1KBody2ClientK,
  placeholder: SlotG1KBody2Placeholder || getPlaceholder({ skip: true }),
  name: 'BundleSpecifications',
});

lazySlots.LazySlotG1KBody2 = withLayout(
  SlotG1KBody2LoadK,

  null
  ,
  {
    waitForComponent: SlotG1KBody2ClientK,
    placeholder: SlotG1KBody2Placeholder || getPlaceholder({ skip: true })
  }
);

const SlotG1KBody3Placeholder = null;

const SlotG1KBody3ClientK = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "bundleproductoverviewaccordiontitle" */
    '@thd-olt-component-react/questions-and-answers');
};

export const SlotG1KBody3LoadK = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
      .QuestionsAndAnswersAccordionBody;
  },
  client: SlotG1KBody3ClientK,
  placeholder: SlotG1KBody3Placeholder || getPlaceholder({ skip: true }),
  name: 'QuestionsAndAnswersAccordionBody',
});

lazySlots.LazySlotG1KBody3 = withLayout(
  SlotG1KBody3LoadK,

  null
  ,
  {
    waitForComponent: SlotG1KBody3ClientK,
    placeholder: SlotG1KBody3Placeholder || getPlaceholder({ skip: true })
  }
);

const SlotG1KBody4Placeholder = null;

const SlotG1KBody4ClientK = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "bundleproductoverviewaccordiontitle" */
    '@thd-olt-component-react/ratings-and-reviews');
};

export const SlotG1KBody4LoadK = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
      .RatingsAndReviewsAccordionBody;
  },
  client: SlotG1KBody4ClientK,
  placeholder: SlotG1KBody4Placeholder || getPlaceholder({ skip: true }),
  name: 'RatingsAndReviewsAccordionBody',
});

lazySlots.LazySlotG1KBody4 = withLayout(
  SlotG1KBody4LoadK,

  null
  ,
  {
    waitForComponent: SlotG1KBody4ClientK,
    placeholder: SlotG1KBody4Placeholder || getPlaceholder({ skip: true })
  }
);

let RulesMiddleware_MiddlewareSlot_SlotG1 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_SlotG1 = withDynamicBundleAccordion(RulesMiddleware_MiddlewareSlot_SlotG1, { render: [{ name: 'QuestionsAndAnswersAccordionTitle' }, { name: 'RatingsAndReviewsAccordionTitle' }] });

const LazySlotG1Accordion = withLayoutAccordion([
  [

    [

      withLayout(
        BundleProductOverviewAccordionTitleSlotG1Header,

      ),

    ],

    [

      withLayout(
        BundleSpecificationsAccordionTitleSlotG1Header,

      ),

    ],

    [

      withLayout(
        QuestionsAndAnswersAccordionTitleSlotG1Header,

      ),

    ],

    [

      withLayout(
        RatingsAndReviewsAccordionTitleSlotG1Header,

      ),

    ],

  ],
  [

    [

      lazySlots.LazySlotG1KBody1,

    ],

    [

      lazySlots.LazySlotG1KBody2,

    ],

    [

      lazySlots.LazySlotG1KBody3,

    ],

    [

      lazySlots.LazySlotG1KBody4,

    ],

  ]
],

RulesMiddleware_MiddlewareSlot_SlotG1
);

// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
  components.forEach((com, index) => {
    // eslint-disable-next-line no-param-reassign
    com.props = hydratedProps[index];
  });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  const ssr = typeof window === 'undefined';
  const decisionIndex = ssr
    ? 0
    : Number(
      (window.__SLOT_DECISIONS__ && window.__SLOT_DECISIONS__[props.slot]) ?? '0'
    );

  if (props.slot === 'SlotG1') {

    return (
      <LazySlotG1Accordion
        {...props}
        config={props.config}
        fusionSlotName="SlotG1"
        fusionComponentName="accordion"
        fusionClassName={slot.fusionClassName}
        isDynamic
        // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
        // queryProvider={{
        //   inherit: 'page',
        //   merge,
        //   queryOptions,
        //   cache key for all accordions must be the same
        //   otherwise a race condition will occur generating duplicate requests
        //   cacheKey: 'page',
        //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
        // }}
      />
    );

  }

  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};
